<template>
    <div style="min-height:90h; max-height:90vh">
        <!-- <vue-markdown :source="content"></vue-markdown> -->
        <div class="container">
            <div class="row">
                <div class="col-1"></div>
                <div class="col-1" style="padding: 5px;">
                    <a href="/function">
                        <img src="../../../../assets//Logo//Logo2.png" alt="" width="120px">
                    </a>
                </div>
                <div class="col-8"></div>
                <div class="col">
                    <div style="max-height:10vh; min-height:10vh; padding:13px">
                    <el-button @click="goBack" type="success" plain>取消</el-button>
                    <el-button @click="outputENter" type="success">确定</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div style="min-height:6vh; max-height: 6vh;">
            <el-input
            maxlength="100"
            show-word-limit
            style="height: 10vh;"
            placeholder="请输入标题"
            v-model="title"
            clearable>
            </el-input>
        </div>
        <div class="home">
        <mavon-editor :codeStyle="codeStyle" :toolbars="toolbars" style="min-height:84vh; max-height: 84vh;" :tabSize="tabSize" v-model="content" :ishljs="true" ref="md" @change="change"/>
        </div>
    </div>
</template>

<script>
    // import VueMarkdown from 'vue-markdown'
    import $ from 'jquery'
    export default {
        name:'UpdateNotes',
        components: {
            // VueMarkdown,
        },
        // props:["allContent"],
        data() {
            return {
                title:'',
                content: "",
                tabSize:4,
                page_article:undefined,
                html_content:undefined,
                md_content:undefined,
                toolbars: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: true, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: true, // 保存（触发events中的save事件）
                    navigation: true, // 导航目录
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    subfield: true, // 单双栏模式
                    preview: true // 预览
                },
                codeStyle:'monokai-sublime',//主题
                test_html:undefined,
            }
        },
        mounted() {
            const notes = this.$store.state.problem.notes

            this.title = notes.title
            this.content = notes.markdown
            this.ReadNotes()
        },
        methods:{
            goBack() {
                this.$router.back(); // 返回上一页
            },
            ReadNotes() {
                const store = this.$store
                const vue = this
                const route = this.$route
                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/getone/',
                    type: "post",
                    data: {
                        id: route.params.id
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            console.log("获取单个题目题解信息成功咯")
                            const one = JSON.parse(resp.one)
                            console.log("one == > ", one)
                            vue.pbid = one.pbid
                            vue.title = one.title
                            vue.content = one.markdown
                            vue.createtime = one.createtime
                            vue.userid = parseInt(one.userid)
                            vue.name = one.name
                            vue.photo = one.photo
                            vue.goods = parseInt(one.goods)

                            store.commit("problem/UPDATENOTES", {
                                id : route.params.id,
                                pbid : one.pbid,
                                title : one.title,
                                markdown : one.markdown,
                                content : one.content,
                                createtime : one.createtime,
                                userid : parseInt(one.userid),
                                name : one.name,
                                photo : one.photo,
                                goods : parseInt(one.goods),
                            })
                        } else {
                            console.log("获取单个题目题解信息失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                })
            },
            outputENter(){ //
                const vue = this
                const store = this.$store
                const route = this.$route
                const router = this.$router

                console.log(JSON.stringify(this.test_html))   //就用这个存数据库  然后进行回显即可
                
                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/api/notes/update/",
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: route.params.id,
                        title: vue.title,
                        markdown: vue.content,
                        content: vue.test_html,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("修改成功了")
                            router.push({
                                name:'ShowNotes',
                                params: {
                                    id: route.params.id,
                                }
                            })
                        } else {
                            console.log("修改失败了, resp == >", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("修改错误了, resp == >", resp)
                    }
                })
            },
            change(value, render){
                this.test_html = render;
            },
        },
    }
</script>

<style scoped>
.hljs{
  font-size: 15px;
}
.info{
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
}
</style>